<template>
  <el-select
    v-model="Month"
    placeholder="mes"
    @change="handleSelection"
    v-bind="$attrs"
    :size="size"
    :disabled="isItDisable"
  >
    <el-option
      v-for="item in MonthsFiltereByQuater"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>
<script>
export default {
  name: "MonthsComponent",
  props: {
    initial: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    Quater: {
      type: Number,
      default: 0
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "mini"
    }
  },
  data() {
    return {
      Month: this.initial, // new Date().getMonth() + 1,
      monthList: [
        { value: 0, label: "Todos" },
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" }
      ]
    };
  },
  computed: {
    MonthsFiltereByQuater() {
      let months = [{ value: 0, label: "Todos" }];

      switch (this.Quater) {
        case 1:
          months = this.monthList.filter(
            (item) => (item.value >= 1 && item.value <= 3) || item.value == 0
          );
          break;
        case 2:
          months = this.monthList.filter(
            (item) => (item.value >= 4 && item.value <= 6) || item.value == 0
          );
          break;
        case 3:
          months = this.monthList.filter(
            (item) => (item.value >= 7 && item.value <= 9) || item.value == 0
          );
          break;
        case 4:
          months = this.monthList.filter(
            (item) => (item.value >= 10 && item.value <= 12) || item.value == 0
          );
          break;
        default:
          months = this.monthList;
      }

      return months;
    },
    isItDisable() {
      return this.isDisabled;
    }
  },
  methods: {
    handleSelection() {
      this.$emit("change", this.Month);
    }
  },
  watch: {
    initial(val) {
      this.Month = val;
    }
  }
};
</script>
<style scoped></style>
